import { canBootstrapCart, getCartElement, isV2TopMenu, canBootstrapCartByType, canBootstrapByEcomState } from '.';
import { fetchCart, fetchCheckoutUrl, IECommerceCart } from '@gn-audio/core/api/e-commerce';
import { isSiteFeatureEnabled } from '@gn-audio/core/common/utilities';
import { SiteFeature } from '@gn-audio/core/api/site-settings/enums/site-feature.enum';

export const bootstrapDRBasketIfPossible = async () => {
  const cartElement: HTMLElement = getCartElement();
  if (!cartElement) {
    return;
  }

  const ecomEnabled: boolean = await canBootstrapByEcomState();
  document.documentElement.classList.add(`ecom-${ecomEnabled ? 'enabled' : 'disabled'}`);
  if (!ecomEnabled) {
    cartElement.style.display = 'none';
    return;
  }

  if (!await canBootstrapCart()) {
    // Enable content cart if SFCC basket is disabled
    if (!canBootstrapCartByType() && !await isSiteFeatureEnabled(SiteFeature.SfccBasket)) {
      cartElement.querySelector('.data').classList.remove('hidden');
    }

    return;
  }

  cartElement.addEventListener('click', () => {
    fetchCheckoutUrl()
      .then((checkoutUrl: string) => { window.location.href = checkoutUrl; });
  });

  if (!isV2TopMenu()) {
    return;
  }

  const cartItemsElement: HTMLElement = cartElement.querySelector('.top-navigation__main-menu__label--cart');
  if (!cartItemsElement) {
    return;
  }

  fetchCart()
    .then((cart: IECommerceCart): void => {
      cartItemsElement.dataset.cartitems = String(cart.totalItemsInCart);
      cartItemsElement.classList.add('cart-loaded');
    });
};
